export default __webpack_public_path__ + "static/media/one.32f81841.jpeg";